(function () {
  var modal = document.getElementById('modal-custom');
  var modalLegacy = document.getElementById('modal-legacy');
  var overlay = document.getElementById('modal-custom-overlay');
  var overlayLegacy = document.querySelector('.modal-custom-overlay-legacy');
  var closeButton = document.getElementById('close-button-modal');
  var closeButtonLegacy = document.querySelector('.close-button-modal-legacy');
  var sendButton = document.getElementById('btnSendNotify');
  var emailInput = document.getElementById('emailNotify');
  var captchaWidgetId = null;
  var captchaToken = '';
  var captchaWidgetReady = false;
  var recaptchaScriptPromise = null;
  var genericErrorMessage = decodeHtml(modal ? modal.getAttribute('data-notify-error-generic') || 'Please try again.' : 'Please try again.');
  var captchaErrorMessage = decodeHtml(modal ? modal.getAttribute('data-notify-error-captcha') || 'Please confirm that you are not a robot.' : 'Please confirm that you are not a robot.');
  var popupTitle = decodeHtml(modal ? modal.getAttribute('data-notify-popup-title') || 'Notification response' : 'Notification response');
  var recaptchaSiteKey = modal ? modal.getAttribute('data-notify-recaptcha-sitekey') || '' : '';

  function decodeHtml(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value;
  }

  function toggleModal(open) {
    if (!modal || !overlay) return;
    var closed = modal.classList.contains('closed-modal-custom');
    var shouldOpen = typeof open === 'boolean' ? open : closed;
    modal.classList.toggle('closed-modal-custom', !shouldOpen);
    overlay.classList.toggle('closed-modal-custom', !shouldOpen);
  }

  function toggleLegacy(open) {
    if (!modalLegacy || !overlayLegacy) return;
    var closed = modalLegacy.classList.contains('closed-modal-custom');
    var shouldOpen = typeof open === 'boolean' ? open : closed;
    modalLegacy.classList.toggle('closed-modal-custom', !shouldOpen);
    overlayLegacy.classList.toggle('closed-modal-custom', !shouldOpen);
  }

  function ensureRecaptchaScript() {
    if (!recaptchaSiteKey) {
      return Promise.reject(new Error('Missing reCAPTCHA site key.'));
    }

    if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
      return Promise.resolve(window.grecaptcha);
    }

    if (recaptchaScriptPromise) {
      return recaptchaScriptPromise;
    }

    recaptchaScriptPromise = new Promise(function (resolve, reject) {
      var existingScript = document.getElementById('notify-recaptcha-api');

      function handleReady() {
        if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
          resolve(window.grecaptcha);
        } else {
          reject(new Error('reCAPTCHA API loaded without grecaptcha.'));
        }
      }

      if (existingScript) {
        existingScript.addEventListener('load', handleReady, { once: true });
        existingScript.addEventListener('error', function () {
          reject(new Error('Failed to load existing reCAPTCHA script.'));
        }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.id = 'notify-recaptcha-api';
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.addEventListener('load', handleReady, { once: true });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load reCAPTCHA script.'));
      }, { once: true });
      document.head.appendChild(script);
    }).catch(function (error) {
      recaptchaScriptPromise = null;
      throw error;
    });

    return recaptchaScriptPromise;
  }

  function ensureRecaptchaWidget() {
    return ensureRecaptchaScript().then(function (grecaptcha) {
      if (captchaWidgetId === null) {
        captchaWidgetId = grecaptcha.render('g-recaptcha', {
          sitekey: recaptchaSiteKey,
          callback: function (token) {
            captchaToken = token || '';
            if (!captchaToken && typeof grecaptcha.getResponse === 'function') {
              captchaToken = grecaptcha.getResponse(captchaWidgetId) || '';
            }
            updateSendState();
          },
          'expired-callback': function () {
            captchaToken = '';
            updateSendState();
          },
          'error-callback': function () {
            captchaToken = '';
            updateSendState();
          }
        });
        window._notifyRecaptchaId = captchaWidgetId;
      } else {
        captchaToken = '';
        grecaptcha.reset(captchaWidgetId);
      }

      captchaWidgetReady = true;
      updateSendState();
      return captchaWidgetId;
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () { toggleModal(false); });
  }
  // Do not auto-close on click; let submit logic decide
  if (closeButtonLegacy) {
    closeButtonLegacy.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleLegacy(false);
    });
  }

  document.addEventListener('click', function (e) {
    var closeLegacy = e.target.closest('.close-button-modal-legacy');
    if (closeLegacy) {
      e.preventDefault();
      e.stopPropagation();
      toggleLegacy(false);
      return;
    }

    if (overlayLegacy && e.target === overlayLegacy) {
      toggleLegacy(false);
      return;
    }

    var btn = e.target.closest('.open-button-modal');
    if (btn) {
      var a = emailInput ? emailInput.value : '';
      var b = btn.getAttribute('data-product-id');
      var c = 0;
      var honey = document.getElementById('honey-pot');
      if (honey) honey.value = '';
      if (sendButton) {
        sendButton.setAttribute('data-customer-email', a || '');
        if (b) sendButton.setAttribute('data-product-id', b);
        sendButton.setAttribute('data-customer-id', c);
      }
      toggleModal(true);
      ensureRecaptchaWidget().catch(function (error) {
        captchaWidgetReady = false;
        updateSendState();
        console.warn('[notify-modal] reCAPTCHA render on open failed:', error);
      });
      // Re-evaluate button enabled state on open
      updateSendState();
    }
    var btnLegacy = e.target.closest('.open-button-modal-legacy');
    if (btnLegacy) {
      e.preventDefault();
      toggleLegacy(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    var triggerLegacy = e.target.closest('.open-button-modal-legacy[role="button"]');
    if (!triggerLegacy) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleLegacy(true);
    }
  });

  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  function getCaptchaToken() {
    var token = captchaToken || '';
    try {
      if (!token && window.grecaptcha && typeof window.grecaptcha.getResponse === 'function') {
        if (captchaWidgetId !== null) {
          token = window.grecaptcha.getResponse(captchaWidgetId) || '';
        } else {
          token = window.grecaptcha.getResponse() || '';
        }
      }
    } catch (e) {}
    if (!token) {
      var dEl = document.querySelector('#g-recaptcha textarea[name="g-recaptcha-response"]') ||
        document.getElementById('g-recaptcha-response') ||
        document.querySelector('textarea[name="g-recaptcha-response"]');
      token = dEl ? (dEl.value || '') : '';
    }
    captchaToken = token;
    return token;
  }

  function updateSendState() {
    if (!sendButton) return;
    var value = (emailInput && emailInput.value) || '';
    var emailValid = value !== '' && isEmail(value);
    sendButton.setAttribute('data-customer-email', value);
    // The old theme rendered reCAPTCHA on page load; keep submit blocked until the widget exists.
    sendButton.disabled = !emailValid || !captchaWidgetReady;
  }

  if (emailInput && sendButton) {
    emailInput.addEventListener('keyup', updateSendState);
    updateSendState();
  }

  if (modal) {
    var notifyForm = modal.querySelector('form');
    if (notifyForm) {
      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        window.notifyDataSend();
      });
    }
  }

  window.notifyDataSend = function () {
    var a = (sendButton && sendButton.getAttribute('data-customer-email')) || '';
    var b = (sendButton && sendButton.getAttribute('data-product-id')) || '';
    var c = 0;
    var d = getCaptchaToken();
    var lang = document.documentElement.getAttribute('lang') || 'it';
    var honey = document.getElementById('honey-pot');
    var isHoneyOk = honey ? honey.value === '' : true;
    if (!isHoneyOk) {
      alert(genericErrorMessage);
      return false;
    }
    if (d === '') {
      alert(captchaErrorMessage);
      return false;
    }
    if (isHoneyOk && d !== '') {
      PopupCenter('https://europe-west1-massivemusic-prod.cloudfunctions.net/emailNotificationSubscribe/notifyme/' + a + '/' + b + '/' + lang + '/' + d, popupTitle, '900', '500');
      toggleModal(false);
      return false;
    }
  };

  function PopupCenter(url, title, w, h) {
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : (document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width);
    var height = window.innerHeight ? window.innerHeight : (document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height);
    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + 800 + ', height=' + 375 + ', top=' + top + ', left=' + left);
    setTimeout(function () {
      location.reload();
      if (newWindow) newWindow.close();
    }, 4000);
    if (window.focus && newWindow) {
      newWindow.focus();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (modal) {
      ensureRecaptchaWidget().catch(function (error) {
        captchaWidgetReady = false;
        updateSendState();
        console.warn('[notify-modal] reCAPTCHA render on load failed:', error);
      });
    }

    var colorEl = document.querySelector('.product-single__title');
    var color = colorEl ? colorEl.getAttribute('data-color') : null;
    if (!color) return;
    setTimeout(function () {
      var wiserHeading = document.querySelector('.evm_wiser_heading');
      if (wiserHeading) wiserHeading.style.backgroundColor = color;
      document.querySelectorAll('.evm-ws-card option[data-out="1"]').forEach(function (opt) {
        var priceEl = opt.closest('select')?.parentElement?.parentElement?.parentElement?.nextElementSibling?.querySelector('.ws-card__price');
        if (priceEl) priceEl.textContent = 'Avvisami';
        var addToCartEl = opt.closest('select')?.parentElement?.parentElement?.parentElement?.nextElementSibling?.querySelector('.wp-addtocart');
        if (addToCartEl) addToCartEl.style.display = 'none';
      });
    }, 200);
  });
})();
